(function () {
  if (window.__cldPdp) return; window.__cldPdp = true;
  var DAYS = ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'];
  function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
  function addCal(d, n) { d = new Date(d); d.setDate(d.getDate() + n); return d; }
  function fmt(d) { return d.getDate() + '. ' + (d.getMonth() + 1) + '.'; }
  function range(a, b) { return a.getMonth() === b.getMonth() ? a.getDate() + '.–' + fmt(b) : fmt(a) + ' – ' + fmt(b); }
  function ship() {
    document.querySelectorAll('[data-cld-ship]').forEach(function (el) {
      if (el.__done) return; el.__done = true;
      var now = new Date(), g = function (k) { return +el.getAttribute('data-' + k) || 0; };
      var b = el.querySelectorAll('[data-ship]');
      if (b[0]) b[0].textContent = 'Dnes, ' + DAYS[now.getDay()] + ' ' + fmt(now);
      if (b[1]) b[1].textContent = range(addBiz(now, g('a')), addBiz(now, g('b')));
      if (b[2]) b[2].textContent = range(addCal(now, g('c')), addCal(now, g('d')));
      var go = function () { el.querySelector('ol').style.setProperty('--cld-ship', '0.5'); };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { go(); io.disconnect(); } }, { rootMargin: '0px 0px -15% 0px' });
        io.observe(el);
      } else go();
    });
  }
  function labels() {
    document.querySelectorAll('.product__info-container .product-form__submit').forEach(function (btn) {
      var span = btn.querySelector('span') || btn;
      var map = { 'Add to cart': 'Přidat do košíku', 'Sold out': 'Vyprodáno', 'Unavailable': 'Nedostupné' };
      var fix = function () { var t = span.textContent.trim(); if (map[t]) span.textContent = map[t]; };
      fix();
      if (!btn.__cldObs && 'MutationObserver' in window) { btn.__cldObs = new MutationObserver(fix); btn.__cldObs.observe(span, { childList: true, characterData: true, subtree: true }); }
    });
  }
  function sticky() {
    var bar = document.querySelector('[data-cld-sticky]');
    var main = document.querySelector('.product__info-container .product-form__submit');
    if (!bar || !main || bar.__done) return; bar.__done = true;
    document.body.appendChild(bar);
    var btn = bar.querySelector('button');
    btn.addEventListener('click', function () {
      if (main.disabled) { main.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      main.click();
    });
    var mainGone = false, ctaVisible = 0;
    function set() {
      var on = mainGone && ctaVisible === 0;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
    }
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (e) {
      var r = e[0]; mainGone = !r.isIntersecting && r.boundingClientRect.top < 0; set();
    }).observe(main);
    var seen = new Set();
    var io2 = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); });
      ctaVisible = seen.size; set();
    });
    document.querySelectorAll('.cld-btn, footer').forEach(function (el) { io2.observe(el); });
  }
  function init() { ship(); labels(); sticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
